/**
 * In The Studio – custom element wrapper for UGC video items.
 * <pi-studio-video> wraps each video for consistent styling and future behavior.
 */
(function () {
  if (typeof window.customElements === 'undefined' || window.customElements.get('pi-studio-video')) return;

  class PiStudioVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var video = this.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
      }
    }
  }

  window.customElements.define('pi-studio-video', PiStudioVideo);
})();
